<template>
    <Background
        :backPath="'prevPage'">
        <div
            class="split-box">
            <div class="info-area">
                <div class="title">
                    货柜信息
                </div>
                <div class="info-paragraph">
                    <div class="info-line">
                        <div class="info-label">货柜编号</div>
                        <div class="content-area">
                            <div class="info-content">{{ machineSerialNum }}</div>
                        </div>
                    </div>

                    <div class="info-line">
                        <div class="info-label">货柜ID</div>
                        <div class="info-content">{{ cupboardId }}</div>
                    </div>
                </div>
                <div class="info-paragraph">
                    <div class="info-line">
                        <div class="info-label">
                            主控编号
                            <a-button
                                v-on:click="watchShell"
                                size="small"
                                class="watch-shell-button">
                                查看主控日志
                            </a-button>
                        </div>
                        <div class="content-area">
                            <div class="info-content">{{ boxSerialNum }}</div>
                        </div>
                    </div>

                    <div class="info-line">
                        <div class="info-label">识别优先级</div>
                        <div class="content-area">
                            <div class="info-content">{{ priority }}</div>
                            <a-icon
                                v-on:click="popEditDialog('priority')"
                                class="edit-button"
                                type="highlight" />
                        </div>
                    </div>
                </div>
                <div class="info-paragraph">
                    <div class="info-line">
                        <div class="info-label">主控状态</div>
                        <div class="content-area">
                            <div class="info-content">{{ boxStatus }}</div>
                        </div>
                    </div>

                    <div class="info-line">
                        <div class="info-label">主控哈希</div>
                        <div class="content-area">
                            <div class="info-content">{{ boxHasPassword }}</div>
                        </div>
                    </div>
                </div>
                <div class="info-paragraph">
                    <div class="info-line">
                        <div class="info-label">网络</div>
                        <div class="content-area">
                            <div class="info-content">{{ onlineStatus }}</div>
                        </div>
                    </div>

                    <div class="info-line">
                        <div class="info-label">设备状态</div>
                        <div class="content-area">
                            <div class="info-content">
                                <div v-if="errors.length > 0">
                                    异常
                                </div>
                                <div v-else>
                                    一切正常
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="online"
                class="error-area">
                <div
                    v-if="errors.length > 0"
                    class="error-title">
                    异常状态:
                </div>
                <div v-if="errors.length > 0">
                    <div
                        v-for="(error, index) in errors"
                        :key="index">
                        {{ error.type }}
                        <div
                            v-for="(suberror, suberrorIndex) in error.errors"
                            :key="suberrorIndex"
                            class="suberror-area"
                        >
                            {{ suberror }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <CupboardEditDialog
            ref="dialog"
            :title="editInfoTitle"
            :hint="editInfoHint"
            :type="editInfoType"
            :successMessage="editInfoSuccessMessage"
            :cupboardNum="editInfoCupboardNum"
            :updateInfoCallback="updateInfo"
        />
    </Background>
</template>

<script>
 import Vue from 'vue';

 import Background from "./Background.vue"

 import Modal from "ant-design-vue/lib/modal";
 import CupboardEditDialog from "./CupboardEditDialog.vue";

 import message from "ant-design-vue/lib/message";
 import { parseDate } from "../util/date.js"

 Vue.component(Modal.name, Modal);

 export default {
     name: 'CupboardInfo',
     data() {
         return {
             cupboardId: "",
             machineSerialNum: "",
             boxSerialNum: "",
             priority: "",
             boxStatus: "",
             boxHasPassword: "",
             online: false,
             onlineStatus: "",
             errors: [],
             log: "",
             username: "",

             editInfoTitle: "",
             editInfoHint: "",
             editInfoType: "",
             editInfoSuccessMessage: "",
             editInfoCupboardNum: ""
         }
     },
     props: {
     },
     components: {
         Background,
         CupboardEditDialog
     },
     computed: {
     },
     mounted() {
         var info = JSON.parse(sessionStorage.getItem("clickCupboardInfo"))

         console.log("***** ", info)

         this.cupboardId = info.Id
         this.machineSerialNum = info.MachineSerialNum
         this.boxSerialNum = info.BoxSerialNum
         this.priority = info.Priority
         this.boxStatus = info.BoxStatus
         this.boxHasPassword = info.BoxHasPassword

         this.username = localStorage.getItem('username');

         this.fetchStatus()
     },
     methods: {
         popEditDialog(type) {
             if (type == "priority") {
                 this.editInfoTitle = "编辑识别优先级",
                 this.editInfoHint = "有效范围：0~255"
                 this.editInfoSuccessMessage = "识别优先级更新成功"
             }

             this.editInfoCupboardNum = this.machineSerialNum
             this.editInfoType = type
             this.$refs.dialog.show()
         },
         updateInfo(type, info) {
             if (type == "priority") {
                 this.priority = info
             }
         },
         watchShell() {
             const url = `${process.env.VUE_APP_API_SERVER}/machine-status/${this.machineSerialNum}`;
             var accessToken = localStorage.getItem('accessToken')
             var data = {
                 "action": "debug",
             }

             var that = this
             fetch(url, {
                 method: 'PUT',
                 body: JSON.stringify(data),
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 console.log("**** ", response)

                 if (that.online) {
                     if (response && response.url) {
                         window.open(response.url)
                     } else {
                         message.destroy()
                         message.error("找不到主控日志授权码")
                     }
                 } else {
                     message.error("主控不在线，无法查看日志，请刷新重试")
                 }
             })
         },
         fetchStatus() {
             const url = `${process.env.VUE_APP_API_SERVER}/machine-status/${this.machineSerialNum}`;
             var accessToken = localStorage.getItem('accessToken')

             var that = this
             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 console.log(response)

                 that.online = response.online
                 if (response.online) {
                     that.onlineStatus = "在线"
                 } else {
                     that.onlineStatus = "离线"
                 }

                 if (response.errors === null) {
                     that.errors = []
                 } else {
                     that.errors = response.errors
                 }

                 console.log(that.errors)
             })
         },
     },
 }
</script>

<style scoped>
 .info-area {
     width: 100%;
     height: 100%;
     padding-top: 80px;
     padding-left: 80px;
     padding-right: 80px;

     background-color: #FFF;

     position: relative;
 }

 .title {
     font-size: 24px;
     margin-left: 30px;
     margin-bottom: 20px;
     text-align: start;
 }

 .info-line {
     display: flex;
     flex-direction: column;
     justify-content: flex-start;
     width: 100%;
     border-right: 1px solid #EEE;
     padding-left: 30px;
 }

 .info-line:last-child {
     border-right: none;
 }

 .info-label {
     font-size: 18px;
     color: #333;
     width: 200px;
     text-align: start;
     margin-bottom: 10px;
     user-select: none;

     display: flex;
     flex-direction: row;
     align-items: center;
 }

 .info-content {
     font-size: 16px;
     color: #999;
     text-align: start;
     height: 24px;
 }

 .info-paragraph {
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: space-around;
     padding-top: 30px;
     padding-bottom: 30px;
     border-bottom: 1px solid #EFEFEF;
 }

 .content-area {
     display: flex;
     flex-direction: row;
     align-items: center;
 }

 .edit-button {
     margin-left: 5px;
     margin-bottom: 2px;
     font-size: 16px;
     color: #333;
     cursor: pointer;
 }

 .edit-button:hover {
     color: #587FE0;
 }

 .delete-button {
     position: absolute;
     bottom: 40px;
 }

 .type-check-group {
     display: flex;
 }

 .split-box {
     display: flex;
     flex-direction: row;
     width: 100%;
     height: 100%;
 }

 .log-area {
     width: 100%;
     background-color: #FFF;
     border-left: 1px solid #DDD;
 }

 .error-title {
     font-size: 20px;
 }

 .error-area {
     width: 100%;
     background-color: #FFF;
     border-left: 1px solid #EEE;

     display: flex;
     flex-direction: column;
     align-items: start;

     padding-top: 20px;
     padding-left: 20px;

     font-size: 16px;
 }

 .suberror-area {
     display: flex;
     flex-direction: column;
     align-items: start;
     margin-left: 20px;
 }

 .watch-shell-button {
     margin-left: 10px;
 }
</style>
